"use client";

import React from "react";
import { Typography } from "@material-tailwind/react";
import ImageBackgroundCard from "@/components/image-bg-card";
import AboutusImageBackgroundCard from "./aboutus-image-back";
export function AboutUsDetails() {
  return (
    <div className="relative min-h-screen w-full  ">
      
      <div className="absolute inset-0 h-full w-full bg-white-700 bg-[url('/image/dot-pattern.png')]  bg-left-top bg-no-repeat" />
     <section className="w-full max-w-5xl mx-auto flex flex-col items-center px-3 py-10 animate-fade-down duration-500"> 
     
        <div className="container relative z-10 my-auto mx-auto grid place-items-center text-center">
       
      
      

          <div className="flex flex-wrap items-center justify-center">
          <div className="lg:w-1/2 mt-10" >
    
    <AboutusImageBackgroundCard image="image/bg1.jpg" />

  </div>
 
  <div className="w-full pl-5 lg:w-1/2">

  
    
  <Typography
                variant="h4"
                className="mb-5 mt-10 w-full text-center font-bold !text-black lg:w-10/12 animate-fade-down duration-500 " placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}           >
            About Company 
          </Typography>
       
          
    <Typography variant="h6" className="mb-2  w-full text-left font-normal !text-black lg:w-20/20 animate-fade-down duration-500" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      Welcome to Hope International Aged Care Training and Elderly Care Center, nestled in the vibrant heart of Kathmandu, Nepal. Our center stands as a beacon of compassion and excellence in caregiver training and elderly care services. Located in the bustling district of Kathmandu, we are committed to empowering individuals with the skills and knowledge necessary to provide exceptional care to elderly members of our community.
    </Typography>

   
   
  </div>
 
</div>

<div className="flex flex-wrap items-center justify-center  ">
  
        
 
  <div className="w-full lg:w-1/2  pl-5">
  <Typography
                variant="h4"
                className="mb-5 mt-10 w-full text-center font-bold !text-black lg:w-10/12 animate-fade-down duration-500"  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}           >
            What We Do
          </Typography>
    
<Typography variant="h6" className=" w-full/2 text-left font-normal !text-black lg:w-20/20 animate-fade-down duration-500 "  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      At Hope International, we offer comprehensive caregiver training packages tailored to levels 1 through 5, ensuring that our trainees are equipped with the expertise needed to meet the diverse needs of aging individuals. Our curriculum covers a wide range of topics, including basic caregiving techniques, specialized care for individuals with conditions such as Alzheimer’s, Parkinson’s, dementia, and more.
    </Typography>
    {/* <Typography variant="h6" className=" w-full text-left font-normal !text-black lg:w-20/20 animate-fade-down duration-500">
      But our commitment doesn’t end with training. We believe in guiding our trainees towards fulfilling and rewarding careers in elderly care. Through personalized career guidance and support, we help individuals navigate their professional paths with confidence and purpose.
    </Typography> */}
  </div>

  <div className="lg:w-1/2 mt-10 " >
    
  <div>
  <AboutusImageBackgroundCard image="image/aboutus2.jpg" />

  </div>
   
  </div>
 
</div>

 
      </div>
      </section>
   
</div>


        
  
  );
  
}
